import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Helmet from 'react-helmet';
import {
  Button,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Box,
  Paper,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';

import { showErrorAction, showMessageAction } from 'containers/Notification/actions';
import { useHandleVerificationRequestMutation } from 'generated/graphql';
import { selectUser } from 'entities/user/selectors';

const VerificationRequestPage = () => {
  const { data } = useParams<{ data: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [handleVerificationRequest, { loading: submitting }] = useHandleVerificationRequestMutation(
    {
      onError: () => {
        dispatch(showErrorAction('Failed to process a request'));
      },
    }
  );
  const { userId, ticketId, nonprofitId } = JSON.parse(atob(data));

  const [isSigned, setIsSigned] = useState(false);

  const userFullName = useSelector(selectUser)?.fullName?.toJS();

  const onSubmit = async () => {
    const response = await handleVerificationRequest({
      variables: { userId, ticketId, nonprofitId },
    });
    if ((response as { errors: unknown }).errors) {
      dispatch(showErrorAction('Failed to verify the user, please try again'));
    } else {
      dispatch(
        showMessageAction(
          'The user has been verified, the Zendesk ticket should have been updated and closed'
        )
      );
      history.replace('/');
    }
  };

  return (
    <Box maxWidth={1200}>
      <Paper variant="outlined" style={{ padding: 24, paddingTop: 0, position: 'relative' }}>
        <Helmet title="Verification request" />
        <h2>
          User verification request{' '}
          <a href={`https://joindeed.zendesk.com/agent/tickets/${ticketId}`}>#{ticketId}</a>
        </h2>

        <Box>
          <Typography>User ID: {userId}</Typography>
          <Typography>Nonprofit ID: {nonprofitId}</Typography>
        </Box>

        <Box display="flex" flexDirection="column" mt={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isSigned}
                onChange={(e) => setIsSigned(e.target.checked)}
                color="primary"
              />
            }
            label={`Sign verification request as ${userFullName?.first} ${userFullName?.last}`}
          />
        </Box>
        <Box position="absolute" bottom={24} right={24}>
          {submitting ? (
            <CircularProgress size={24} />
          ) : (
            <Button
              color="primary"
              onClick={onSubmit}
              disabled={submitting || !isSigned}
              variant="contained"
            >
              Verify the user
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default VerificationRequestPage;
